module.exports = __webpack_public_path__ + "media/images/media/media1-78cda213cbbdca66ceca3985fee2198f.jpg";